module.exports = __webpack_public_path__ + "img/5手机.990ee310.png";